import TemplateView from '../../TemplateView'
import {WorkflowStatusType} from '../constants'
import {workflowStatusComparator} from '../utils'
import messageResource from '../../messageResource'
import {getInstance as getTooltipInstance} from '../../SimpleSingletonTooltip'

export class WorkflowStatusList extends TemplateView {
    constructor({
                    groupRenderer = null,
                    statusRenderer = null,
                    additionalClass = '',
                    showGroups = true,
                }) {
        super(null)

        this.state = {
            statuses: [],
            inactiveOpenStatuses: false,
            showCompletedFirst: false,
            hideCompleted: false,
            showChangeStatusLabel: false,
            showReopenLabel: false,
            showGroups: showGroups,
        }

        this.params = {
            groupRenderer,
            statusRenderer,
            additionalClass,
            showGroups,
        }

        this.onAnyStatePropertyChanged(['statuses', 'hideCompleted', 'showGroups'], () => {
            if (this.rendered) {
                this._renderStatuses()
            }

            this.$el.toggleClass('grouped', this.state.showGroups)
        })

        this.onStatePropertyChanged('inactiveOpenStatuses', (inactiveOpenStatus) => {
            this.$openStatuses.toggleClass('inactive', inactiveOpenStatus)
            if (inactiveOpenStatus) {
                getTooltipInstance().subscribeToMouseEvents(this.$openStatuses, () => {
                    getTooltipInstance().setState({
                        text: messageResource.getMessage('task.list.tooltip.task.inactive_open_statuses'),
                        extraClass: 'workflowStatusList_inactiveOpenStatusesTooltip',
                    })
                })
            }
        })

        this.onStatePropertyChanged('showCompletedFirst', (showCompletedFirst) => {
            this.$statusesListContainer.toggleClass('showCompletedFirst', showCompletedFirst)
        })

        this.onStatePropertyChanged('showChangeStatusLabel', (show) => {
            this.$changeStatusLabel.toggle(show)
        })

        this.onStatePropertyChanged('showReopenLabel', (show) => {
            this.$reopenLabel.toggle(show)
        })

        this.onAnyStatePropertyChanged(['showCompletedFirst', 'showReopenLabel', 'hideCompleted'], () => {
            this.$completedStatuses.toggleClass("withBottomBorder", this.state.showCompletedFirst && this.state.showReopenLabel && !this.state.hideCompleted)
        })
    }

    templateHtml() {
        return '<div class="workflowStatus_components_workflowStatusList <%=additionalClass%>">' +
               '    <div class="changeStatusLabel actionName"><%-changeStatusLabel%></div>' +
               '    <div class="statusesListContainer">' +
               '      <div class="openStatuses">' +
               '          <div class="cover"></div>' +
               '          <div class="reopenLabel actionName"><%-reopenLabel%></div>' +
               '          <div class="openStatusesContainer"></div>' +
               '      </div>' +
               '      <div class="completedStatuses">' +
               '          <div class="completedStatusesContainer"></div>' +
               '      </div>' +
               '    </div>' +
               '</div>'
    }

    templateModel() {
        return {
            additionalClass: this.params.additionalClass,
            changeStatusLabel: messageResource.getMessage('workflow_list.change_status'),
            reopenLabel: messageResource.getMessage('workflow_list.reopen'),
        }
    }

    afterRender(){
        this.$openStatusesContainer = this.$el.find('.openStatusesContainer')
        this.$openStatuses = this.$el.find('.openStatuses')
        this.$completedStatuses = this.$el.find('.completedStatuses')
        this.$completedStatusesContainer = this.$el.find('.completedStatusesContainer')
        this.$statusesListContainer = this.find('.statusesListContainer')
        this.$reopenLabel = this.find('.reopenLabel')
        this.$changeStatusLabel = this.find('.changeStatusLabel')
    }

    _renderStatuses() {
        this.$openStatusesContainer.empty()
        this.$completedStatusesContainer.empty()

        const openStatuses = []
        const completedStatuses = []

        const sorted = this.state.statuses.sort(workflowStatusComparator)
        sorted.forEach(status => {
            if (status.type === WorkflowStatusType.OPEN) {
                openStatuses.push(status)
            } else {
                completedStatuses.push(status)
            }
        })

        if (openStatuses.length !== 0) {
            if (this.state.showGroups) {
                this.params.groupRenderer(this.$openStatusesContainer, WorkflowStatusType.OPEN)
            }

            openStatuses.forEach((status) => {
                this.params.statusRenderer(this.$openStatusesContainer, status)
            })
        }

        if (completedStatuses.length !== 0 && !this.state.hideCompleted) {
            if (this.state.showGroups) {
                this.params.groupRenderer(this.$completedStatusesContainer, WorkflowStatusType.COMPLETED)
            }

            completedStatuses.forEach((status) => {
                this.params.statusRenderer(this.$completedStatusesContainer, status)
            })
        }
    }
}

export default WorkflowStatusList



// WEBPACK FOOTER //
// ./web/js/workflowStatus/components/WorkflowStatusList.js